import { onAuthStateChanged } from "@firebase/auth";
import { createContext, useEffect, useState } from "react";
import { auth } from "../firebase";
import * as Sentry from "@sentry/react";


export const AuthContext = createContext<any>({});

export const AuthContextProvider: React.FC<any> = ({ children }) => {
  interface AuthData {
    uid: string;
  }
  const [currentUser, setCurrentUser] = useState<AuthData>({
    uid: ""
  });
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    // Safety timeout: if auth never resolves (Firebase init failure, network issue),
    // set authReady after 10s so the app doesn't show a permanent loading screen.
    const timeout = setTimeout(() => {
      setAuthReady((prev: boolean) => {
        if (!prev) {
          console.error("[AuthContext] Auth initialization timed out after 10s");
          Sentry.captureMessage("Auth initialization timed out after 10s", "warning");
        }
        return true;
      });
    }, 10000);

    const unsub = onAuthStateChanged(
      auth,
      (user: any) => {
        clearTimeout(timeout);
        Sentry.addBreadcrumb({
          category: "auth",
          message: user ? `Auth state changed: signed in (${user.uid})` : "Auth state changed: signed out",
          level: "info",
        });
        if (user) {
          Sentry.setUser({ id: user.uid });
          setCurrentUser(user);
        } else {
          Sentry.setUser(null);
          setCurrentUser({ uid: "" });
        }
        // New fix for redirect to login bug. Second part is to /
        // insure authReady is only set to true once.////////////
        setAuthReady((prev: boolean) => (prev ? prev : true));
      },
      (error) => {
        clearTimeout(timeout);
        console.error("[AuthContext] onAuthStateChanged error:", error);
        Sentry.captureException(error);
        // Set authReady so the app doesn't get stuck on loading screen
        setAuthReady(true);
      }
    );
    return () => {
      clearTimeout(timeout);
      unsub();
    };
  }, []);

  return (
    <AuthContext.Provider value={{ currentUser, authReady }}>
      {children}
    </AuthContext.Provider>
  );
};
